/**
 * The Research Analyst plans' data helpers (V063, owner's decision of 26 Oct
 * 2026): three plans by client places, read from /platform/plans (role "ra",
 * public), so an admin's change in Admin → Plans shows on the site. What each
 * plan adds comes from its `features`.
 */
import type { Plan, PlansResponse } from "@/pages/account/platform";

/** Public, active RA plans, cheapest first. */
export function raPlans(data: PlansResponse | undefined): Plan[] {
  return (data?.plans ?? [])
    .filter((p) => p.role === "ra" && p.active && p.public !== false && p.price_monthly > 0)
    .sort((a, b) => a.sort_order - b.sort_order || a.price_monthly - b.price_monthly);
}

/** What every RA plan includes. */
export const RA_INCLUDES = [
  "Every research tool (the full membership)",
  "Publish calls with SEBI disclosures added for you",
  "A track record nobody can edit",
  "Invite clients by email: their accounts are free",
  "Calls delivered in the app, by email and on WhatsApp",
];

const on = (p: Plan, key: string) => p.features?.[key] === true;

/** The lines a plan adds on top of the plan before it. */
export function planExtras(p: Plan): string[] {
  const out: string[] = [];
  if (on(p, "featured")) out.push("Featured listing in the Research Analyst directory");
  if (on(p, "search_priority")) out.push("Priority in directory search");
  if (on(p, "branded_profile")) out.push("Branded public profile page");
  if (on(p, "team_logins")) out.push("Team logins (coming soon)");
  if (on(p, "priority_support")) out.push("Priority support");
  return out;
}

/** The directory query for the home page's two boxes: a 6-digit "where" is a PIN code. */
export function directorySearch(name: string, where: string): Record<string, string> {
  const out: Record<string, string> = {};
  const n = name.trim();
  const w = where.trim();
  if (n) out.q = n;
  if (/^[1-9]\d{5}$/.test(w)) out.pincode = w;
  else if (w) out.city = w;
  return out;
}
